export default {
  pendingLabel: 'Pendiente',
  openedLabel: 'Abierto',
  holdingLabel: 'En Espera',
  repliedLabel: 'Respondido',
  closedLabel: 'Cerrado',
  ignoredLabel: 'Ignorado',
};
